// Vendor libraries
import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
// Constants
import { REPORT_TYPE_LABELS, INDIVIDUAL_LEVEL, SECURITY_A, CUSTOM, DEFAULT_SECURITY_LEVEL, } from 'CustomPDFReportsApp/ts/constants';
// NgRx
import { getCurrentWizardStepIndex, getSelectedReport, getAllSecurities, getSecurityLevelValues, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
import { decrementCurrentWizardStep, incrementCurrentWizardStep, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
import { setDollarConversionLevels } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/dollar-conversion-level-selector/dollar-conversion-level.actions';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import * as i0 from "@angular/core";
import * as i1 from "SecuritiesApp/ts/services/securities.service";
import * as i2 from "@ngrx/store";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
function DollarConversionLevelSelectorModalComponent_tr_15_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "td")(2, "span", 18);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 19);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "td", 20)(7, "input", 21);
    i0.ɵɵlistener("change", function DollarConversionLevelSelectorModalComponent_tr_15_Template_input_change_7_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.customLevelChangeHandler($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const security_r5 = ctx.$implicit;
    const index_r6 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", index_r6 + 1, ".");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(security_r5.securityName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("readonly", ctx_r3.securityLevel !== "Custom" || index_r6 > 0)("value", ctx_r3.securityLevelValues[index_r6] || 10000);
} }
function DollarConversionLevelSelectorModalComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵlistener("click", function DollarConversionLevelSelectorModalComponent_div_21_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.back()); });
    i0.ɵɵtext(1, "Back ");
    i0.ɵɵelementEnd();
} }
/**
 * Dollar Conversion Level Selector Modal Component
 *
 *
 *
 * Output Properties:
 *  broadcastWizardStepEvent: emits when moving to the next wizard step in the report generation process.
 *
 */
export class DollarConversionLevelSelectorModalComponent {
    constructor(securitiesService, store) {
        this.securitiesService = securitiesService;
        this.store = store;
        this.broadcastWizardStepEvent = new EventEmitter();
        this.currentReportIndex = null;
        this.currentWizardStepIndex = null;
        this.isLoading = true;
        this.modalOpen = false;
        this.currentReportTypeInternalName = '';
        this.securityLevelValues = [];
        this.errorMessage = '';
        this.submitButtonText = 'Start';
        this.reportMenuFetchSubscription = null;
        this.customSecurityLevel = DEFAULT_SECURITY_LEVEL;
        this.isAlive = true;
        this.headerText = 'Generate Report';
        this.selectedReport = {};
        this.selectedReportType = '';
        this.securityLevel = INDIVIDUAL_LEVEL;
        this.securities = [];
        this.securitiesInfo = [];
        this.securityLevelDropdownCssConfig = {
            button: 'btn btn-secondary btn-block style-underline',
        };
        this.securityLevelDropdownConfig = {
            list: [
                { value: INDIVIDUAL_LEVEL, label: 'Individual Level' },
                { value: SECURITY_A, label: 'Security A' },
                { value: CUSTOM, label: 'Custom' },
            ],
        };
        this.mapStateToComponent = (state) => {
            this.selectedReport = getSelectedReport(state);
            this.currentWizardStepIndex = getCurrentWizardStepIndex(state);
            this.selectedReportType = this.selectedReport.report_type ?? null;
            this.securities = getAllSecurities(state);
            this.securityLevelValues = getSecurityLevelValues(state);
            this.headerText = this.selectedReportType
                ? `Generate ${REPORT_TYPE_LABELS[this.selectedReportType]} Report`
                : 'Generate Report';
        };
        this.storeSubscription = this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.isAlive = false;
        this.storeSubscription.unsubscribe();
    }
    openModal() {
        this.modalOpen = true;
        if (this.securityLevel !== CUSTOM) {
            this.fetchSecuritiesLevelInfo();
        }
    }
    fetchSecuritiesLevelInfo() {
        this.securitiesService
            .getSecuritiesLevelsInfo(this.securities.map((security) => security.securityId).join(','))
            .subscribe({
            next: (response) => {
                this.securitiesInfo = response;
                if (this.securityLevel === INDIVIDUAL_LEVEL) {
                    this.store.dispatch(setDollarConversionLevels({
                        securityLevelValues: this.securitiesInfo.map((security) => security.current_level || DEFAULT_SECURITY_LEVEL),
                    }));
                }
                else {
                    this.store.dispatch(setDollarConversionLevels({
                        securityLevelValues: this.securitiesInfo.map(() => this.securitiesInfo[0].current_level || DEFAULT_SECURITY_LEVEL),
                    }));
                }
            },
            error: () => {
                this.errorText = 'Unable to load individual levels for selected securities';
            },
        });
    }
    closeModal() {
        this.modalOpen = false;
        this.errorText = undefined;
    }
    back() {
        this.closeModal();
        this.store.dispatch(decrementCurrentWizardStep());
    }
    exitModalHandler() {
        this.closeModal();
        this.store.dispatch(resetAllCustomPdfReportItems());
    }
    forward() {
        this.closeModal();
        this.store.dispatch(incrementCurrentWizardStep());
        this.broadcastWizardStepEvent.emit();
    }
    customLevelChangeHandler(event) {
        if (this.securityLevel === CUSTOM) {
            this.customSecurityLevel = +event.target.value;
            this.securityLevelValues = this.securities.map(() => this.customSecurityLevel);
            this.store.dispatch(setDollarConversionLevels({ securityLevelValues: this.securityLevelValues }));
        }
    }
    securityLevelOptionChangeHandler(value) {
        this.securityLevel = value;
        if (this.securityLevel === CUSTOM) {
            this.securityLevelValues = this.securities.map(() => this.customSecurityLevel);
            this.store.dispatch(setDollarConversionLevels({ securityLevelValues: this.securityLevelValues }));
        }
        else if (this.securitiesInfo.length > 0) {
            // Check if we have already pulled the level info for the securities
            if (this.securityLevel === INDIVIDUAL_LEVEL) {
                this.store.dispatch(setDollarConversionLevels({
                    securityLevelValues: this.securitiesInfo.map((security) => security.current_level || DEFAULT_SECURITY_LEVEL),
                }));
            }
            else {
                this.store.dispatch(setDollarConversionLevels({
                    securityLevelValues: this.securitiesInfo.map(() => this.securitiesInfo[0].current_level || DEFAULT_SECURITY_LEVEL),
                }));
            }
        }
        else {
            this.fetchSecuritiesLevelInfo();
        }
    }
}
DollarConversionLevelSelectorModalComponent.ɵfac = function DollarConversionLevelSelectorModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DollarConversionLevelSelectorModalComponent)(i0.ɵɵdirectiveInject(i1.SecuritiesService), i0.ɵɵdirectiveInject(i2.Store)); };
DollarConversionLevelSelectorModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DollarConversionLevelSelectorModalComponent, selectors: [["ycn-dollar-conversion-level-selector-modal"]], outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, decls: 26, vars: 7, consts: [["helpModal", ""], [3, "closeModalHandler", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section", "mb-3"], [1, "text-gray-30"], [1, "help-toggler", 3, "click"], [1, "mb-2"], [1, "form-label", "form-label-thin", "pb-1"], ["data-test-id", "security-level-select-dropdown", 1, "dropdown", "width-140", 3, "changeHandler", "config", "selectedValue", "customCssClasses"], [1, "table"], [4, "ngFor", "ngForOf"], [1, "modal-footer"], [1, "modal-footer-info"], [1, "btn", "btn-text", 3, "click"], [1, "modal-footer-actions"], ["class", "btn btn-secondary", 3, "click", 4, "ngIf"], ["data-test-id", "submit-dollar-conversion-level", 1, "btn", "btn-primary", 3, "click"], [1, "mr-1", "text-default"], [1, "text-default"], ["clss", "pl-0"], ["data-test-id", "dollar-conversion-level-input", "type", "number", 1, "form-control", "disabled", "ng-scope", 3, "change", "readonly", "value"], [1, "btn", "btn-secondary", 3, "click"]], template: function DollarConversionLevelSelectorModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function DollarConversionLevelSelectorModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 2);
        i0.ɵɵlistener("closeModalHandler", function DollarConversionLevelSelectorModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 3)(3, "div", 4)(4, "p")(5, "span", 5);
        i0.ɵɵtext(6, "Select a security level to use for the dollar-enabled securities in your report.\u00A0 ");
        i0.ɵɵelementStart(7, "span", 6);
        i0.ɵɵlistener("click", function DollarConversionLevelSelectorModalComponent_Template_span_click_7_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r2 = i0.ɵɵreference(25); return i0.ɵɵresetView(helpModal_r2.openModal("dollar_value_security_level_selection")); });
        i0.ɵɵtext(8, "(?)");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(9, "div", 7)(10, "label", 8);
        i0.ɵɵtext(11, "Security Level");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "ycn-single-select-dropdown", 9);
        i0.ɵɵlistener("changeHandler", function DollarConversionLevelSelectorModalComponent_Template_ycn_single_select_dropdown_changeHandler_12_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.securityLevelOptionChangeHandler($event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "table", 10)(14, "tbody");
        i0.ɵɵtemplate(15, DollarConversionLevelSelectorModalComponent_tr_15_Template, 8, 4, "tr", 11);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(16, "div", 12)(17, "div", 13)(18, "div", 14);
        i0.ɵɵlistener("click", function DollarConversionLevelSelectorModalComponent_Template_div_click_18_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵtext(19, "Cancel");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(20, "div", 15);
        i0.ɵɵtemplate(21, DollarConversionLevelSelectorModalComponent_div_21_Template, 2, 0, "div", 16);
        i0.ɵɵelementStart(22, "div", 17);
        i0.ɵɵlistener("click", function DollarConversionLevelSelectorModalComponent_Template_div_click_22_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.forward()); });
        i0.ɵɵtext(23, "Next ");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelement(24, "ycn-help-modal", null, 0);
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.headerText);
        i0.ɵɵadvance(11);
        i0.ɵɵproperty("config", ctx.securityLevelDropdownConfig)("selectedValue", ctx.securityLevel)("customCssClasses", ctx.securityLevelDropdownCssConfig);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.securities);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.currentWizardStepIndex != 0);
    } }, dependencies: [i3.NgForOf, i3.NgIf, i4.HelpModalComponent, i5.ModalBaseComponent, i6.SimpleModalHeaderComponent, i7.SingleSelectDropdownComponent], encapsulation: 2 });
